// extracted by mini-css-extract-plugin
export default {"noDocs":"FileManager_noDocs__D32eW"};